/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import Colors from '@ziynx/theme/colors';

type Props = $ReadOnly<{|
    color?: string,
    opacity?: number,
    zIndex?: number,
|}>;

const OverlayWrapper = styled.div`
    width: 100%;
    height: auto;
    color: ${({ color }) => color};
    opacity: ${({ opacity }) => opacity};
    z-index: ${({ zIndex }) => zIndex};
`;

const Overlay = (props: Props): React$Node => {
  const { color, opacity, zIndex } = props;
  return (
    <OverlayWrapper color={color} opacity={opacity} zIndex={zIndex} />
  );
};

Overlay.defaultProps = {
  color: Colors.GrayVeryLight,
  opacity: 0.85,
  zIndex: 998,
};

export default Overlay;
